import { render } from '@testing-library/react';
import React from 'react'
import '../App.css';
import { BrowserRouter, Route, Switch, withRouter} from 'react-router-dom';
import Edit from './EditSlideshows'
import ImageIcon from '../images/ImageIcon.svg'
import VideoIcon from '../images/VideoIcon.svg'

class File extends React.Component {
    constructor(){
        super();
        this.state = {
            type: ""
        };
    }

    handleChange = (e) =>{
        this.props.addRemove(e.target.checked, this.props.url, this.props.id);
    }

    render(){
        return(
            
            <div className="FileContainer">
                <img className="fileType" src={this.props.type === "png" ? ImageIcon : VideoIcon}/>
                <input type="checkbox" id="FileCheckbox" onChange={this.handleChange}></input>
                <img className="ImgFile" src={this.props.url} hidden={this.props.type === "png" ? false : true}></img>
                <video className="VidFile" src={this.props.url} type="video/mp4" hidden={this.props.type === "mp4" ? false : true}></video>
            </div>
        )
    }
}
export default withRouter(File);

//this.props.type === "png" ? './images/ImageIcon.svg' : '../images/ImageIcon.svg' 
                //<button className="trashFileBtn"/>